<template>
  <div>
    <ProductDetail
      type="edit"
      :submitting="submitting"
      :values="data"
      :default-gtip="defaultGtip"
      @submit="submit"
      @defaultGtip="setDefaultGtip"
    />
  </div>
</template>

<script>
import { helper } from '@core/mixins/helper';
import ProductDetail from '@/views/pages/products/ProductDetail.vue';
import useService from '@/auth/service/useService';

export default {
  components: {
    ProductDetail
  },
  mixins: [helper],

  data() {
    return {
      submitting: false,
      data: {},
      defaultGtip: null
    };
  },

  created() {
    const productId = this.$route.params.id;
    this.getProductDetail(productId);
  },

  methods: {
    submit(data) {
      const requestData = {
        description: data.description,
        gtip_id: data.gtip,
        currency_id: data.currency_code.value,
        origin_id: data.origin.value,
        merchant_product_id: data.merchant_product_id || null,
        manufacturer_product_id: data.manufacturer_product_id || null,
        standard_product_id: data.standard_product_id || null
      };

      this.submitting = true;
      const productId = this.$route.params.id;
      useService
        .editProduct(productId, requestData)
        .then(response => {
          this.$router.push('/products');
          this.showSuccessMessage(
            `${
              response.message ||
              (this.type === 'new'
                ? this.$t('Create Product Success Message')
                : this.$t('Edit Product Success Message'))
            }`
          );
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    getProductDetail(productId) {
      this.submitting = true;
      useService
        .getProduct(productId)
        .then(response => {
          this.data = {
            ...response.data,
            currency_code: {
              text: this.getCurrencyCode(response.data.currency.code),
              value: response.data.currency.id
            },
            origin: {
              text: response.data.originCountry.name,
              value: response.data.originCountry.id
            },
            gtip: response.data.gtip.id,
            merchant_product_id: response.data.merchant_product_id || '',
            manufacturer_product_id: response.data.manufacturer_product_id || '',
            standard_product_id: response.data.standard_product_id || ''
          };

          this.defaultGtip = {
            text: response.data.gtip.code,
            value: response.data.gtip.id
          };
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    setDefaultGtip(data) {
      this.defaultGtip = data;
    }
  }
};
</script>
